/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';

import { Button } from 'antd';

import { FormattedMessage } from 'react-intl';
import TTIcon from 'static/img/svg/TT.svg';

import { onDownloadDataClick } from '../downloadGpsTT.services';

const NotInstalledTTView = (props) => {
  const handleOnClick = () => {
    onDownloadDataClick('TourstartTransfer');
  };

  const handleUpdate = () => {
    props.launchEmptyTT();
    props.closeDownloadGps(false);
  };

  return (
    <div className="transferDropDown">
      <div className="transfer-dropdown-wrap-block">
        <div className="hide-history-route-text" />
        <div className="dropDownSvg">
          <img src={TTIcon} alt="" style={{ height: 105, width: 200 }} />
        </div>
        {props.isNeedUpdateExistedTT ? (
          <div className="TransferDescription">
            <p>
              <FormattedMessage
                id="There is a new update"
                defaultMessage="There is a new update"
              />
              <br />
              <FormattedMessage
                id="for your Tourstart Transfer"
                defaultMessage="for your Tourstart Transfer"
              />
              .
              <br />
              <br />
              <br />
            </p>
          </div>
        ) : (
          <div className="TransferDescription">
            <p style={{ marginBottom: '15px' }}>
              <FormattedMessage
                id="We have made it easy for you to"
                defaultMessage="We have made it easy for you to"
              />
              <br />
              <FormattedMessage
                id="transfer your motorcycle tours"
                defaultMessage="transfer your motorcycle tours"
              />
              <br />
              <FormattedMessage
                id="to any GPS device"
                defaultMessage="to any GPS device"
              />
              .
            </p>
            <p style={{ marginBottom: 0 }}>
              <FormattedMessage
                id="Just install the program on your"
                defaultMessage="Just install the program on your"
              />
              <br />
              <FormattedMessage
                id="computer and experience how"
                defaultMessage="computer and experience how"
              />
              <br />
              <FormattedMessage id="easy it is" defaultMessage="easy it is" />.
            </p>
          </div>
        )}
      </div>
      <div className="btn">
        {props.isNeedUpdateExistedTT ? (
          <Button onClick={handleUpdate} type="primary" className="transferBtn">
            <span>
              <FormattedMessage id="Update" defaultMessage="Update" />
            </span>
          </Button>
        ) : (
          <Button
            onClick={() => handleOnClick()}
            type="primary"
            className="transferBtn"
          >
            <span>
              <FormattedMessage
                id="Download Tourstart Transfer"
                defaultMessage="Download Tourstart Transfer"
              />
            </span>
          </Button>
        )}
      </div>
      {/* <MoreOptionView {...props}/> */}
    </div>
  );
};

export default NotInstalledTTView;
